<template>
  <b-modal
    id="shipment_info_modal"
    :title="'Embarque ' + shipment.boarding_number"
    @show="handleShow"
    @hide="handleHide"
  >
    <!-- Stacked Table -->
    <div v-if="!emptyShipment">
      <div>
        <h2>Información General del Embarque</h2>
        <ul>
          <li><strong>Agente Aduana:</strong> {{ shipment.custom_agent_company.name }}</li>
          <li><strong>Exportador:</strong> {{ shipment.exporter_company.name }}</li>
          <li><strong>Shipper:</strong> {{ shipment.shipper_company.name }}</li>
          <li><strong>Consignee:</strong> {{ shipment.consignee_company.name }}</li>
          <li><strong>Notify:</strong> {{ shipment.notify_company.name }}</li>
          <li><strong>Planta:</strong> {{ shipment.plant_company.name }}</li>
          <li><strong>Fecha de Embarque:</strong> {{ shipment.shipment_date | timezone }}</li>
          <li><strong>Numero de Embarque:</strong> {{ shipment.boarding_number }}</li>
          <li><strong>Tipo de Embarque:</strong> {{ shipment.shipment_type.name }}</li>
          <li><strong>País:</strong> {{ shipment.country.name }}</li>
          <li><strong>Estado de Embarque:</strong> {{ getStatus(shipment.shipment_status) }}</li>
        </ul>
        <hr />

        <h2>Detalles del Transporte</h2>
        <ul>
          <li><strong>Vessel:</strong> {{ shipment.vessel }}</li>
          <li><strong>Shipping Line:</strong> {{ shipment.shipping_line.name }}</li>
          <li><strong>Aerolínea:</strong> {{ shipment.air_line }}</li>
          <li><strong>AWB:</strong> {{ shipment.bl_awb }}</li>
          <li><strong>Transportista:</strong> {{ shipment.transport_company }}</li>
        </ul>

        <hr />
        <h2>Información de Ruta y Puertos</h2>
        <ul>
          <li><strong>Puerto Carga:</strong> {{ shipment.loading_port.name }}</li>
          <li><strong>Puerto Destino:</strong> {{ shipment.destination_port.name }}</li>
          <li><strong>Aeropuerto de Salida:</strong> {{ shipment.airport_departure }}</li>
          <li><strong>Aeropuerto de Llegada:</strong> {{ shipment.airport_arrival }}</li>
          <li><strong>Vuelo:</strong> {{ shipment.fligth }}</li>
          <li><strong>Vuelo de Conexión:</strong> {{ shipment.connection_fligth }}</li>
          <li><strong>Ruteo:</strong> {{ shipment.routing }}</li>
        </ul>
        <hr />

        <h2>Fechas Clave</h2>
        <ul>
          <li><strong>Fecha de Carga:</strong> {{ shipment.date_loading | timezone }}</li>
          <li><strong>Fecha de Corte:</strong> {{ shipment.cut_date | timezone }}</li>
          <li><strong>ETA ó Fecha de Llegada:</strong> {{ shipment.eta | timezone }}</li>
          <li><strong>ETD ó Fecha de Entrega:</strong> {{ shipment.etd | timezone }}</li>
          <li><strong>Fecha de Entrega Aeropuerto:</strong> {{ shipment.date_delivery_airport | timezone }}</li>
        </ul>
        <hr />

        <h2>Información de Contenedores y Carga</h2>
        <ul>
          <li><strong>Contenedores:</strong> {{ shipment.containers }}</li>
          <li><strong>Numero de Sello:</strong> {{ shipment.seal_number }}</li>
          <li><strong>Bill of Loading:</strong> {{ shipment.bill_loading }}</li>
          <li><strong>Depot:</strong> {{ shipment.depot }}</li>
          <li><strong>Numero de DUS:</strong> {{ shipment.dus_number }}</li>
          <li><strong>Planta de refrigeración:</strong> {{ shipment.refrigerating_plant }}</li>
          <li><strong>Pallets:</strong> {{ shipment.total_pallets }}</li>
          <li><strong>Cajas:</strong> {{ shipment.total_boxes }}</li>
          <li><strong>Contenedores (detalles adicionales):</strong> {{ shipment.box_containers }}</li>
        </ul>
        <hr />

        <h2>Detalles Financieros y Comerciales</h2>
        <ul>
          <li><strong>Modo de Venta:</strong> {{ shipment.sale_mode }}</li>
          <li><strong>Forma de Pago:</strong> {{ shipment.payment_form }}</li>
          <li><strong>Condición de Venta:</strong> {{ shipment.sale_clause }}</li>
          <li><strong>Modo de Flete:</strong> {{ shipment.freight_mode }}</li>
          <li><strong>Moneda:</strong> {{ shipment.currency }}</li>
          <li><strong>PO Number:</strong> {{ shipment.po_number }}</li>
          <li><strong>Flete:</strong> {{ shipment.freight }}</li>
          <li><strong>Seguro:</strong> {{ shipment.insurance }}</li>
          <li><strong>Numero de Factura:</strong> {{ shipment.invoice_number }}</li>
          <li><strong>Fecha de Factura:</strong> {{ shipment.invoice_date | timezone }}</li>
        </ul>
        <hr />

        <h2>Especificaciones del Producto y del Embarque</h2>
        <ul>
          <li><strong>Productos:</strong> {{ shipment.products }}</li>
          <li><strong>Ventilación:</strong> {{ shipment.ventilation }}</li>
          <li><strong>Temperatura:</strong> {{ shipment.temperature }}</li>
          <li><strong>Atmósfera:</strong> {{ shipment.atmosphere }}</li>
          <li><strong>Gases:</strong> {{ shipment.gas }}</li>
          <li><strong>Nota:</strong> {{ shipment.note }}</li>
          <li><strong>Late arrival:</strong> {{ shipment.late_arrival }}</li>
          <li><strong>SPS:</strong> {{ shipment.sps }}</li>
          <li><strong>Booking Number:</strong> {{ shipment.booking_number }}</li>
        </ul>
      </div>
    </div>
    <div class="text-center" v-if="emptyShipment">
      <b-spinner></b-spinner>
    </div>
  </b-modal>
</template>
<script>
import moment from "moment";
export default {
  name: "ModalShipmentInfo",
  data() {
    return {
      shipment: {}
    };
  },
  computed: {
    emptyShipment() {
      return Object.keys(this.shipment).length === 0;
    }
  },
  filters: {
    timezone(value) {
      if (!value) return "";
      return moment.utc(value).local().format("YYYY-MM-DD HH:mm");
    }
  },
  methods: {
    getStatus(value) {
      // (1, "Abierto"),
      //   (2, "Despachado"),
      //   (3, "Nulo"),
      //   (4, "Con carga"),
      //   (5, "Con problemas"),
      //   (6, "Liquidado"),

      switch (value) {
        case 1:
          return "Programado";
        case 2:
          return "Despachado";
        case 3:
          return "Nulo";
        case 4:
          return "Con carga";
        case 5:
          return "Con problemas";
        case 6:
          return "Liquidado";
        default:
          return "Desconocido";
      }
    },
    handleShow() {
      if (!this.selectedShipment) return;
      this.$axios
        .get(`/api/comex/shipment/${this.selectedShipment}/detailed_shipment/`)
        .then((response) => {
          this.shipment = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleHide() {
      this.shipment = {};
    }
  },
  props: {
    selectedShipment: {
      type: String
    }
  }
};
</script>
<style></style>
